import React from 'react';
import LicenseList from './LicenseList';

const AllLicenses = () => (
  <div className="page-content">
    <LicenseList />
  </div>
);

export default AllLicenses; 